import { default as uniqid } from 'uniqid'; // eslint-disable-line import/no-named-default
import { AuthStrategy, DafAuthConfig, AuthToken, DafAuthError } from '../types';
import { MAX_RETRY_COUNT } from '../constants';

export abstract class DafAuthStrategy<T extends DafAuthConfig = DafAuthConfig> implements AuthStrategy<T> {
    protected dafEndpoint: string;

    constructor(dafEndpoint: string) {
        this.dafEndpoint = dafEndpoint;
    }

    supports(config: T): boolean {
        return config.tokenSource === 'DAF';
    }

    public authenticate(config: T, retryCount: number = 0): Promise<AuthToken<T>> {
        return Promise.resolve({
            id: uniqid(),
            tokenValue: 'UNAUTHENTICATED',
            config
        });
    }

    protected async handleDafError(e: Error, config: T, retryCount: number) {
        // Attempt retry because TPS limit has been reached, but not more than maximum retries
        if (e.message === DafAuthError.TPS_LIMIT_REACHED && retryCount < MAX_RETRY_COUNT) {
            // waiting 1 second for the tenant to reset and allow the request through
            await new Promise((resolve) => setTimeout(resolve, 1000));
            return this.authenticate(config, retryCount + 1);
        }
        throw e;
    }
}
